<template>
  <b-modal 
    id="crear-derivacion"
    v-model="isVisible"
    size="xl" 
    hide-footer
    no-close-on-backdrop
    @hidden="onHidden"
  >
    <div>
      <form-wizard
        color="#17a2b8"
        :title="null"
        :subtitle="null"
        shape="square"
        layout="horizontal"
        finish-button-text="Crear"
        back-button-text="Retroceder"
        next-button-text="Siguiente"
        class="wizard-vertical mb-3"
        @on-complete="formSubmitDerivacion"
        ref="wizard"
      >
        <template v-slot:footer="props">
          <hr>
          <div class="wizard-footer-left">
            <b-button
              v-if="props.activeTabIndex > 0"
              :style="props.fillButtonStyle"
              @click="props.prevTab()"
              class="wizard-button"
              variant="primary"
            >
              Atras
            </b-button>
          </div>
          <div class="wizard-footer-right">
            <b-button
              v-if="!props.isLastStep"
              @click="nextTab(props)"
              variant="primary"
              class="wizard-button"
              :style="props.fillButtonStyle"
            >
              Siguiente
            </b-button>
            <b-button
              v-if="props.isLastStep"
              @click="onCrearDerivacion()"
              variant="primary"
              class="wizard-button"
              :style="props.fillButtonStyle"
            >
              Finalizar
            </b-button>
          </div>
        </template>

        <tab-content
          title="Información de la Derivación"
          :before-change="validationInfoDerivacion"
        >
          <StepInformacionDerivacion/>
        </tab-content>

        <tab-content 
          title="Diagnóstico / Servicio a solicitar"
          :before-change="validationDiagnosticoServicio"
          v-if="!isContraReferencia"
        >
          <StepDiagnosticoServicio/>
        </tab-content>

        <tab-content 
          title="Contra Ref / Inf Técnica" 
          v-if="isVisibleStepContraReferencia"
        >
          <StepContraReferencia/>
        </tab-content>

        <tab-content 
          title="Histopatología / Finalizar"
          :before-change="validationFormEncuesta"
        >
          <b-row v-if="!isContraReferencia">
            <b-form-checkbox 
              class="mt-2" 
              v-model="hispatologia" 
              switch 
              :disabled="isContraReferencia"
            >
              Histopatología 
            </b-form-checkbox>
          </b-row>
          <b-row v-if="hispatologia && !isContraReferencia">
            <Formulario013aDev :hispatologia="hispatologia" :isdev="true" />
          </b-row>
        </tab-content>
      </form-wizard>
    </div>
  </b-modal>  
</template>

<script>
import { mapState } from 'vuex';
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import "vue2-timepicker/dist/VueTimepicker.css";
import { required } from "@validations";
import rutas from "@/assets/utils/rutas.json";
import Formulario013aDev from "@/views/procesoclinico/components/Formularios/Formulario013aDev.vue";
import axios from "axios";
import StepInformacionDerivacion from "./StepInformacionDerivacion.vue";
import StepDiagnosticoServicio from "./StepDiagnosticoServicio.vue";
import StepContraReferencia from "./StepContraReferencia.vue";
import { derivacionesService } from '../../services';

export default {
  name: "DerivacionModalCompletar",

  components: {
    FormWizard,
    TabContent,
    StepInformacionDerivacion,
    StepDiagnosticoServicio,
    StepContraReferencia,
    Formulario013aDev
  },

  data() {
    return {
      isVisible: false,
      idDerivacion: null,
      hispatologia: false,
      isVisibleStepContraReferencia: false,
      isContraReferencia: false,
      isInformeTecnicoEnabled: false, // Nueva variable
      isUpdating: false,
      diagnosticosearch: null,
      esPrincipal: false,
      hideEsPrincipal: false,
      tipodeatencion: "Consulta Externa",
      diagnosticos: [],
      nivelseleccionado: null,
      terapiahormonal: null,
      gestacion: null,
      feccita: null,
      itemsproc: [],
      itemsaten: [],
      titularsel: null,
      tokencita: "",
      required,
      date: null,
      paciente: null,
      doctor: null,
      estadoCita: null,
      searchQuery: "",
      searchQueryDoctor: "",
      itemsti: [],
      encuesta: "",
      tokenDerivacion: null,
      config: {
        enableTime: true,
        dateFormat: "Y-m-d H:i",
      },
      filteredItems: [],
      generar: true,
      items: [],
      isLoading: false,
      derivacionespecialidad: null,
      tipoderivacion: null,
      motivoderivacion: null,
      fechaCita: null,
      searchFailed: null,
      showEditModal: false,
      searchAten: "",
      esurgente: null,
      editForm: {
        tipo: "",
        diagnostico: "",
        principal: false,
      },
      editingIndex: -1,
      hallazgosderivacion: null,
    };
  },

  created() {
    this.tokenDerivacion = this.$route.query.completar;
  },

  methods: {
    onHidden() {
      this.$store.commit('setModalCompletarDerivacion', { 
        zData: null,
        dataForm: null,
        isInformeTecnicoEnabled: false // Reiniciar al cerrar
      });
      this.isInformeTecnicoEnabled = false;
    },

    hasValidHistopatologiaData(hispatologia) {
      if (!hispatologia) return false;
      const { form1, form2, form3, dataAntecedentes } = hispatologia;
      const hasForm1Data = form1 && Object.values(form1).some((value) => value !== null && value !== "");
      const hasForm2Data = form2 && (
        (form2.materiales && form2.materiales.length > 0) ||
        (form2.macroscopica && form2.macroscopica !== "") ||
        (form2.ultimaCitologia && form2.ultimaCitologia !== "")
      );
      const hasForm3Data = form3 && Object.values(form3).some((value) => value !== null && value !== "");
      const hasDataAntecedentesData = dataAntecedentes && Object.values(dataAntecedentes).some((value) => value !== null && value !== "");
      return hasForm1Data || hasForm2Data || hasForm3Data || hasDataAntecedentesData;
    },

    async onGetDataDerivacion() {
      if (!this.tokenDerivacion) {
        console.error('No tokenDerivacion proporcionado');
        return;
      }
      const dataDerivacion = await derivacionesService.getByToken(this.tokenDerivacion);
      if (!dataDerivacion) {
        console.error('No se pudo obtener data de la derivación');
        return;
      }
      console.log('Datos de derivación recibidos:', JSON.stringify(dataDerivacion, null, 2));

      const especialidad = {
        value: dataDerivacion.especialidad?.id,
        text: dataDerivacion.especialidad?.descripcion,
        codEsp: dataDerivacion.especialidad?.codEsp
      };
      const esUrgente = dataDerivacion.esurgente === '1';
      const tipoDocumento = dataDerivacion.tipoderivacionId 
        ? {
            value: String(dataDerivacion.tipoderivacionId.id),
            text: dataDerivacion.tipoderivacionId.descripcion
          } 
        : { value: null, text: '' };

      this.isContraReferencia = tipoDocumento.value === '3';
      const motivoDerivacion = dataDerivacion.motivoderivacionId
        ? {
            value: dataDerivacion.motivoderivacionId.id,
            text: dataDerivacion.motivoderivacionId.descripcion
          }
        : { value: null, text: '' };
      const hallazgos = dataDerivacion.hallazgosDerivacion || '';
      const imagenes = dataDerivacion.imagenesDerivacion 
        ? JSON.parse(dataDerivacion.imagenesDerivacion)
        : [];
      const laboratorios = dataDerivacion.laboratoriosDerivacion 
        ? JSON.parse(dataDerivacion.laboratoriosDerivacion)
        : [];
      const procedimientos = dataDerivacion.procedimientoDerivacion 
        ? JSON.parse(dataDerivacion.procedimientoDerivacion)
        : [];
      const atenciones = dataDerivacion.atencionDerivacion 
        ? JSON.parse(dataDerivacion.atencionDerivacion)
        : [];
      const diagnosticos = dataDerivacion.diagnosticoDerivacion 
        ? JSON.parse(dataDerivacion.diagnosticoDerivacion)
        : [];
      const contrareferencia = dataDerivacion.contrareferencia 
        ? JSON.parse(dataDerivacion.contrareferencia) 
        : { terapeuticos: '', recomendado: '' };
      const informaciontecnica = dataDerivacion.informaciontecnica 
        ? JSON.parse(dataDerivacion.informaciontecnica) 
        : { fecha: null, dirigido: '', observaciones: '' };
      const hispatologia = dataDerivacion.hispatologia 
        ? JSON.parse(dataDerivacion.hispatologia) 
        : null;

      const derivacionMapped = {
        ...dataDerivacion,
        especialidad,
        esUrgente,
        tipoDocumento,
        motivoDerivacion,
        hallazgos,
        diagnosticos,
        imagenes,
        laboratorios,
        procedimientos,
        atenciones,
        contrareferencia,
        informaciontecnica,
        hispatologia
      };

      const dataForm = {
        tipoDerivacion: tipoDocumento,
        motivoDerivacion,
        observacion_motder: dataDerivacion.observacionMotder || '',
        cuadroClinico: dataDerivacion.cuadroClinico || '',
        hallazgos: hallazgos || '',
        esUrgente,
        especialidad,
        diagnosticos,
        atenciones,
        procedimientos,
        imagenes,
        laboratorios
      };

      const stepContraReferencia = {
        contrareferencia: derivacionMapped.contrareferencia,
        informe: derivacionMapped.informaciontecnica
      };

      this.isUpdating = true;
      // Corregir la lógica de inicialización de hispatologia
      this.hispatologia = !this.isContraReferencia && this.hasValidHistopatologiaData(hispatologia);
      this.isVisibleStepContraReferencia = tipoDocumento.value === "3" || tipoDocumento.value === "4";
      this.isInformeTecnicoEnabled = !!informaciontecnica; // Inicializar switch
      this.isVisible = true;
      this.$store.commit('setModalCompletarDerivacion', {
        zData: derivacionMapped,
        dataForm,
        stepContraReferencia,
        stepHispatologia: hispatologia
      });
      this.$nextTick(() => {
        this.isUpdating = false;
      });
      console.log('dataForm inicializado:', JSON.stringify(dataForm, null, 2));
      console.log('tipoDocumento:', JSON.stringify(tipoDocumento, null, 2));
      console.log('hispatologia inicializado:', this.hispatologia);
      console.log('isVisibleStepContraReferencia inicializado:', this.isVisibleStepContraReferencia);
      console.log('stModalCompletarDerivacion:', JSON.stringify(this.stModalCompletarDerivacion, null, 2));
    },

    async onCrearDerivacion() {
      console.log('stepContraReferencia antes del envío:', JSON.stringify(this.stModalCompletarDerivacion.stepContraReferencia, null, 2));
      const { dataForm, stepContraReferencia, stepHispatologia } = this.stModalCompletarDerivacion;

      const diagnosticos = !this.isContraReferencia && dataForm.diagnosticos?.length 
        ? JSON.stringify(dataForm.diagnosticos)
        : null;
      const laboratorios = !this.isContraReferencia && dataForm.laboratorios?.length
        ? JSON.stringify(dataForm.laboratorios)
        : null;
      const imagenes = !this.isContraReferencia && dataForm.imagenes?.length
        ? JSON.stringify(dataForm.imagenes)
        : null;
      const atenciones = !this.isContraReferencia && dataForm.atenciones?.length
        ? JSON.stringify(dataForm.atenciones)
        : null;
      const procedimientos = !this.isContraReferencia && dataForm.procedimientos?.length
        ? JSON.stringify(dataForm.procedimientos)
        : null;

      let motDerivacion = null;
      if (!this.isContraReferencia && dataForm.motivoDerivacion) {
        motDerivacion = dataForm.motivoDerivacion.value
          ? dataForm.motivoDerivacion.value
          : await this.crearMotivoDerivacion(dataForm.motivoDerivacion.text);
      }

      const contrareferenciaData = stepContraReferencia?.contrareferencia 
        ? stepContraReferencia.contrareferencia 
        : this.stModalCompletarDerivacion.zData?.contrareferencia || { terapeuticos: '', recomendado: '' };
      // const informaciontecnicaData = stepContraReferencia?.informe 
      //   ? stepContraReferencia.informe 
      //   : this.stModalCompletarDerivacion.zData?.informaciontecnica || { fecha: null, dirigido: '', observaciones: '' };
      const informaciontecnicaData = this.isInformeTecnicoEnabled && stepContraReferencia?.informe ? stepContraReferencia.informe : null;
      const hispatologiaData = this.hispatologia && !this.isContraReferencia ? stepHispatologia : null;

      const variables = {
        tokenDerivacion: this.tokenDerivacion,
        estadoDerivacion: "0",
        tipoderivacionId: dataForm.tipoDerivacion?.value || null,
        motivoderivacionId: motDerivacion,
        observacionMotder: dataForm.observacion_motder || '',
        cuadroClinico: dataForm.cuadroClinico || '',
        hallazgosDerivacion: dataForm.hallazgos || '',
        esUrgente: dataForm.esUrgente ? "1" : "0",
        diagnosticos: diagnosticos,
        laboratorios: laboratorios,
        imagenes: imagenes,
        atenciones: atenciones,
        procedimientos: procedimientos,
        contrareferencia: JSON.stringify(contrareferenciaData),
        informaciontecnica: informaciontecnicaData ? JSON.stringify(informaciontecnicaData) : null,
        hispatologia: hispatologiaData ? JSON.stringify(hispatologiaData) : null
      };

      console.log('Parámetros enviados a actualizarDerivacion:', JSON.stringify(variables, null, 2));
      const result = await derivacionesService.completarRegistro(variables);
      if (result.status === 'success') {
        await this.$swal.fire({
          icon: "success",
          text: "¡Completado con éxito!"
        });
      } else {
        await this.$swal.fire({
          icon: "error",
          text: "¡Ups... Algo pasó!"
        });
      }
      await this.$router.push({ name: 'derivaciones' });
      this.$router.go(0);
    },

    formSubmitDerivacion() {},

    async crearMotivoDerivacion(params) {
      const query = `
        mutation MyMutation($descripcion: String!) {
          crearMotivoDerivacion(descripcion: $descripcion) {
            message
            status
            motivoderivacion {
              id
              descripcion
            }
          }
        }
      `;
      const variables = { descripcion: params };
      try {
        const response = await axios.post(rutas.axios + 'api', { query, variables });    
        if (response.status !== 200) return null;
        return response.data.data.crearMotivoDerivacion.motivoderivacion.id;
      } catch (error) {
        console.log("No se pudo crear el motivo de la derivación", error);
      }
    },

    nextTab(props) {
      if (this.isContraReferencia && props.activeTabIndex === 0) {
        props.nextTab();
        props.nextTab();
      } else {
        props.nextTab();
      }
    },

    validationInfoDerivacion() {
      return new Promise((resolve, reject) => {
        this.isContraReferencia = this.stDataForm?.tipoDerivacion?.value === '3';
        const camposIncompletos = !this.stDataForm?.tipoDerivacion || 
                                 (!this.isContraReferencia && !this.stDataForm?.motivoDerivacion);

        if (camposIncompletos) {
          this.$swal({
            title: 'Campos Incompletos',
            text: 'Por favor complete los campos obligatorios',
            icon: 'error',
          });
          reject();
        } else {
          resolve(true);
        }
      });
    },

    validationDiagnosticoServicio() {
      return new Promise((resolve, reject) => {
        const hasDiagnosticos = this.stDataForm?.diagnosticos?.length > 0;
        const hasLaboratorios = this.stDataForm?.laboratorios?.length > 0;
        const hasImagenes = this.stDataForm?.imagenes?.length > 0;
        const hasAtenciones = this.stDataForm?.atenciones?.length > 0;
        const hasProcedimientos = this.stDataForm?.procedimientos?.length > 0;

        const camposIncompletos = !hasDiagnosticos || 
                                 (!hasLaboratorios && !hasImagenes && !hasAtenciones && !hasProcedimientos);

        if (camposIncompletos) {
          let errorMessage = 'Por favor complete al menos un diagnóstico';
          errorMessage += ' y al menos uno de los siguientes: laboratorios, imágenes, atenciones o procedimientos';
          this.$swal({
            title: 'Campos Incompletos',
            text: errorMessage,
            icon: 'error',
          });
          reject();
        }
        resolve(true);
      });
    },

    async fetchEncuestaCita() {
      const query = `
        query obtenerEncuestaPorTokenAleatorio($tokenaleatorio: String!) {
          allEncuestacita(tokenaleatorio: $tokenaleatorio) {
            calificacion
            estado
            fechaCreacion
            id
            observaciones
            token
            tokenaleatorio
            ultimoCambio
          }
        }
      `;
      const tokenaleatorio = this.tokencita;

      try {
        const response = await axios.post(rutas.axios + "api", {
          query,
          variables: { tokenaleatorio },
        });

        if (
          response.data.data.allEncuestacita 
          && response.data.data.allEncuestacita.length > 0 
          && response.data.data.allEncuestacita[0].calificacion
        ) {
          await this.$swal({
            icon: "success",
            title: "Éxito",
            text: "El paciente ingresó la calificación. Puede continuar.",
          });
          this.encuesta = response.data.data.allEncuestacita[0].calificacion;
        } else {
          await this.$swal({
            icon: "error",
            title: "Error",
            text: "El paciente aún no ha ingresado la calificación.",
          });
        }
      } catch (error) {
        console.error("An error occurred while fetching the options:", error);
      }
    },
  },

  computed: {
    ...mapState({
      stModalCompletarDerivacion: state => state.derivaciones.modalCompletarDerivacion,
      stDataForm: state => state.derivaciones.modalCompletarDerivacion.dataForm
    }),
  },

  watch: {
    tokenDerivacion: {
      deep: true,
      handler(newValue) {
        if (!newValue) return;
        this.onGetDataDerivacion();
      }
    },
    isVisible: {
      deep: true,
      handler(newValue) {
        if (!newValue) this.$router.push({ name: 'derivaciones' });
      }
    },
    '$route.query.completar': {
      handler(newValue) {
        this.tokenDerivacion = newValue;
      }
    },
    hispatologia(newValue) {
      console.log('watch hispatologia: Cambio detectado', newValue);
      if (newValue && !this.isContraReferencia && !this.stModalCompletarDerivacion.zData?.hispatologia) {
        this.$store.commit('setModalCompletarDerivacion', {
          zData: {
            ...this.stModalCompletarDerivacion.zData,
            hispatologia: {}
          }
        });
      }
    },
    'stDataForm.tipoDerivacion': {
      deep: true,
      handler(newValue) {
        console.log('watch stDataForm.tipoDerivacion: Cambio detectado', JSON.stringify(newValue, null, 2)); 
        this.isVisibleStepContraReferencia = newValue?.value === '3' || newValue?.value === '4'; 
        this.isContraReferencia = newValue?.value === '3';
        if (this.isContraReferencia) {
          this.hispatologia = false;
          this.isInformeTecnicoEnabled = false;
        }
      }
    },
    stModalCompletarDerivacion: {
      deep: true,
      handler(newValue) {
        if (this.isUpdating) {
          console.log('Evitando actualización cíclica en stModalCompletarDerivacion', new Date().toISOString());
          return;
        }
        this.isUpdating = true;
        if (!this.isContraReferencia) {
          this.hispatologia = this.hasValidHistopatologiaData(newValue.zData?.hispatologia);
        } else {
          this.hispatologia = false;
        }
        console.log('hispatologia actualizado:', this.hispatologia, new Date().toISOString());
        this.$nextTick(() => {
          this.isUpdating = false;
        });
      }
    }
  },
};
</script>